export enum CourseSubmission {
  Submitted,
  NotSubmitted,
}
